import React from 'react';
import { Provider } from 'react-redux';

import store from './Redux/store';
import AppRouter from './Router/AppRouter';

import './Style/App.css';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

export default App;
